document.addEventListener('DOMContentLoaded', () => {
    const menuEl = document.querySelector('#city-menu');
    const buttonEl = document.querySelector('#city-menu-button');

    if (!menuEl || !buttonEl) return;

    const rootEl = buttonEl.closest('.navbar-city-dropdown');
    let isOpen = false;

    const setOpen = (open) => {
        isOpen = open;
        menuEl.classList.toggle('is-open', open);
        buttonEl.classList.toggle('is-open', open);
        buttonEl.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuEl.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    buttonEl.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        setOpen(!isOpen);
    });

    menuEl.querySelectorAll('.navbar-city-dropdown__item').forEach((item) => {
        item.addEventListener('click', () => {
            const href = item.dataset.href;
            if (href) {
                window.location.href = href;
            }
        });
    });

    document.addEventListener('click', (event) => {
        if (!isOpen || !rootEl) return;
        if (!rootEl.contains(event.target)) {
            setOpen(false);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen) {
            setOpen(false);
        }
    });
});